import { useEffect, useState } from "react";

/** The value after it has stopped changing for `delayMs`. */
export const useDebouncedValue = <T>(value: T, delayMs = 300): T => {
  const [settled, setSettled] = useState(value);
  useEffect(() => {
    const timer = setTimeout(() => setSettled(value), delayMs);
    return () => clearTimeout(timer);
  }, [value, delayMs]);
  return settled;
};

export const formatDateTime = (value: string) =>
  new Date(value).toLocaleString("ko-KR");

/** Search text as the API wants it: trimmed, absent when empty. */
export const searchParam = (text: string): string | undefined =>
  text.trim() === "" ? undefined : text.trim();
